/**
 * 添加绑定事件
 * 
 * events格式为
 *  {
 *    '事件名称': [函数a, 函数b],
 *    ....
 *  }
 * 
 * @Author: Focci
 * @Date: 2023-08-03 21:41:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-03 21:41:29
 */

import PropTypes from 'prop-types'
import { useMap } from 'react-map-gl'
import { forEach, isArray } from 'lodash-es'
import { useEffect } from 'react'

function doEvent(type, events, mapbox) {
  forEach(events, (callbacks, eventName) => {
    isArray(callbacks) && callbacks.forEach((callback) => {
      mapbox[type](eventName, callback)
    })
  })
}

export default function MapboxEvents({
  events = {}
}) {
  const { current: mapbox } = useMap()

  useEffect(() => {
    doEvent('on', events, mapbox)
    return () => {
      doEvent('off', events, mapbox)
    }
  }, [events, mapbox])
}

MapboxEvents.propTypes = {
  events: PropTypes.object,
}
